import {filterHomeReportsForMegaDash} from './filterHomeReportsForMegaDash';

/**
 * Busca `/report/list` e aplica o mesmo filtro do card MegaDash na home.
 *
 * @param {Function} post - `useDispatchPost()`
 * @param {object} ctx
 * @param {string} ctx.clientId
 * @param {string|null|undefined} ctx.userGroupType
 * @param {string|null|undefined} ctx.userGroupId
 * @param {string|null|undefined} ctx.userId
 * @param {boolean|undefined} ctx.canAccessReports
 * @param {string|undefined|null} ctx.manager
 * @returns {Promise<Array<object>>}
 */
export async function fetchFilteredHomeReports(post, ctx) {
	const {clientId, userGroupType, userGroupId, userId, canAccessReports, manager} = ctx;

	if (!clientId) {
		return [];
	}

	const responseData = await post('/report/list', {clientId});
	let associatePdvsData = [];

	if (userGroupType === 'association' && userGroupId) {
		const associatePDVs = await post('/group/chain-list', {id: userGroupId, type: 'child'});
		associatePdvsData = associatePDVs.data || [];
	}

	return filterHomeReportsForMegaDash(responseData.data, {
		userGroupType,
		userGroupId,
		userId,
		canAccessReports,
		manager,
		associatePdvsData,
	});
}
